import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import DeleteBlockedDialog from "@common/components/deleteBlockedDialog/DeleteBlockedDialog";
import { useTranslation } from "@localization/useTranslation";
import { legalEntityContactBlockerTranslationKeys } from "./DeleteLegalEntityContactDialog.types";
import { useDeleteLegalEntityContactHooks } from "./DeleteLegalEntityContactDialog.hooks";

export interface IDeleteLegalEntityContactDialog {
    onCloseDialog: () => void;
    onDeleted: () => void;
    contactId: string;
    contactName: string;
}

function DeleteLegalEntityContactDialog(props: IDeleteLegalEntityContactDialog) {
    const { translateString } = useTranslation();
    const { deleteContact, inProgess, blockedDeletion } = useDeleteLegalEntityContactHooks(props);

    if (blockedDeletion) {
        return (
            <DeleteBlockedDialog
                header={translateString("legalEntityContactCannotBeDeletedHeader")}
                description={translateString("legalEntityContactCannotBeDeletedDescription", { name: props.contactName })}
                blockers={blockedDeletion.blockers}
                blockerTranslationKeys={legalEntityContactBlockerTranslationKeys}
                onDialogClose={props.onCloseDialog}
            />
        );
    }

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.contactName}
            onDialogClose={props.onCloseDialog}
            onOkClick={deleteContact}
            inProgress={inProgess}
        />
    );
}

export default DeleteLegalEntityContactDialog;
